export const LEARN_PATH = '/learn'
export const LEARN_PRACTICE_PATH = '/learn/practice'
export const LEARN_STATS_PATH = '/learn/stats'

export function practiceHubPath(isKidMode: boolean): string {
  return isKidMode ? '/games' : LEARN_PRACTICE_PATH
}
